// https://codepen.io/UstymUkhman/pen/jpZGZW
import { vertexShader, fragmentShader } from './shader';
import { debounce } from '../../helper/utils';

export default function Snow(canvas) {
  if (canvas === null || canvas.nodeName !== 'CANVAS') {
    throw new Error('No Canvas element provided');
  }
  let gl;
  let program;
  let vertices;
  let time;
  let resolution;
  let renderFrame;
  const ELEMENTS = 2;

  function loadShader(type) {
    const source = type === gl.VERTEX_SHADER ? vertexShader : fragmentShader;
    const shader = gl.createShader(type);

    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.log(`An error occurred compiling the shaders: ${gl.getShaderInfoLog(shader)}`);
      gl.deleteShader(shader);
      return null;
    }

    return shader;
  }

  function createProgram() {
    const fragment = loadShader(gl.FRAGMENT_SHADER);
    const vertex = loadShader(gl.VERTEX_SHADER);
    program = gl.createProgram();

    gl.attachShader(program, fragment);
    gl.attachShader(program, vertex);
    gl.linkProgram(program);

    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      console.log(`Unable to initialize shader program: ${gl.getprogramLog(program)}`);
    }
  }

  function render(now) {
    gl.uniform1f(time, now * 0.001);
    gl.drawArrays(gl.TRIANGLES, 0, vertices);

    renderFrame = requestAnimationFrame(render);
  }

  function onWindowResize() {
    gl.canvas.width = gl.canvas.parentElement.offsetWidth;
    gl.canvas.height = gl.canvas.parentElement.offsetHeight;

    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    gl.uniform2fv(resolution, [gl.canvas.width, gl.canvas.height]);
  }

  window.addEventListener('resize', debounce(onWindowResize, 200));

  function createScene() {
    const BUFFER = gl.createBuffer();
    const COORDS = new Float32Array([
      -1.0, 1.0,
      1.0, 1.0,
      1.0, -1.0,

      -1.0, 1.0,
      1.0, -1.0,
      -1.0, -1.0,
    ]);

    gl.clearColor(0.0, 0.0, 0.0, 0.0);
    gl.clearDepth(1.0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);

    gl.bindBuffer(gl.ARRAY_BUFFER, BUFFER);
    gl.bufferData(gl.ARRAY_BUFFER, COORDS, gl.STATIC_DRAW);

    vertices = COORDS.length / ELEMENTS;
    time = gl.getUniformLocation(program, 'time');
    resolution = gl.getUniformLocation(program, 'resolution');
    program.position = gl.getAttribLocation(program, 'position');

    gl.enableVertexAttribArray(program.position);
    gl.vertexAttribPointer(program.position, ELEMENTS, gl.FLOAT, false, 0, 0);

    gl.useProgram(program);

    onWindowResize();

    renderFrame = requestAnimationFrame(render);
  }

  function onWindowLoad() {
    gl = canvas.getContext('webgl');
    createProgram();
    createScene();
  }

  onWindowLoad();

  return {
    pause() {
      cancelAnimationFrame(renderFrame);
    },
    play() {
      cancelAnimationFrame(renderFrame);
      renderFrame = requestAnimationFrame(render);
    },
    update() {
      onWindowResize();
    },
  };
}
